import { connect } from "react-redux";
import objectPath from "object-path";
import Header from "./header/Header";
import HeaderMobile from "./header/HeaderMobile";
import AsideLeft from "./aside/AsideLeft";
import ScrollTop from "../../app/partials/layout/ScrollTop";
import HTMLClassService from "./HTMLClassService";
import LayoutConfig from "./LayoutConfig";
import MenuConfig from "./MenuConfig";
import LayoutInitializer from "./LayoutInitializer";
import NotoficationPanel from "../../app/partials/layout/NotoficationPanel";
import KtContent from "./KtContent";
import "./assets/Base.scss";

const htmlClassService = new HTMLClassService();

function Layout({
  children,
  asideDisplay,
  subheaderDisplay,
  selfLayout,
  layoutConfig,
  treedata,
  quickoptiondata,
  maplayer,
  contentContainerClasses,
}) {
  htmlClassService.setConfig(layoutConfig);
  const contentCssClasses = htmlClassService.classes.content.join(" ");

  return selfLayout !== "blank" ? (
    <LayoutInitializer
      menuConfig={MenuConfig}
      layoutConfig={LayoutConfig}
      htmlClassService={htmlClassService}
    >
      {/* <!-- begin:: Header Mobile --> */}
      <HeaderMobile />
      <div className="kt-grid kt-grid--hor kt-grid--root">
        {" "}

        <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver kt-page">
          {" "}
          {" "}
          {asideDisplay && (
            <>
              <AsideLeft />
            </>
          )}{" "}

          <div
            className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor kt-wrapper"
            id="kt_wrapper"          >
            <Header />
            <div
              id="kt_content"
              className={`kt-content ${contentCssClasses} kt-grid__item kt-grid__item--fluid kt-grid kt-grid--hor`}            >
              <KtContent>
                {children}
              </KtContent>{" "}
            </div>{" "}
          </div>
        </div>{" "}
      </div>
      <NotoficationPanel />
      <ScrollTop />
    </LayoutInitializer>
  ) : (
    // BLANK LAYOUT
    <div className="kt-grid kt-grid--ver kt-grid--root">
      <KtContent> {children}</KtContent>
    </div>
  );
}

const mapStateToProps = ({
  builder: { layoutConfig },
  functionaltree,
  quickoptions,
  sidebardashboard,
  maplayer,
}) => ({
  layoutConfig,
  selfLayout: objectPath.get(layoutConfig, "self.layout"),
  asideDisplay: objectPath.get(layoutConfig, "aside.self.display"),
  subheaderDisplay: objectPath.get(layoutConfig, "subheader.display"),
  desktopHeaderDisplay: objectPath.get(
    layoutConfig,
    "header.self.fixed.desktop"
  ),
  contentContainerClasses: "",
  treedata: functionaltree.treedata,
  quickoptiondata: quickoptions.quickoptiondata,
  maplayer: maplayer.maplayer,

});

export default connect(mapStateToProps)(Layout);
